import { ExModule } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state: State = {
  todos: [
    {
      id: 1,
      name: "Storybook",
      done: false
    },
    {
      id: 2,
      name: "Vuex",
      done: true
    }
  ],
  nextTaskId: 3
};

const todoModule: ExModule<State, Actions, Getters, Mutations> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default todoModule;
